"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
(0, core_1.addRoute)({
    name: "contractEvents",
    path: "/contract-events",
    component: "ContractEvents"
});
let ContractEvents = class ContractEvents extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
        this.$$cache_dsParams = new core_1.ComponentValueCache(this, "dsParams", "ContractEvents.dsParams");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    gridName;
    dsParams;
    async $$load_dsParams() {
        return {
            date_from: this.$fn.today(),
            date_to: null,
        };
    }
    selectedItems;
    ds;
    async $$load_ds() {
        return this.$fn.slickDataSource('browse_contract_events', {
            parameters: () => this.dsParams
        });
    }
    ux;
    b_7315092382398562_modalBindings;
    b_2248226175642056_columnDefaults;
    b_2248226175642056_columns;
    dataMembers = ['gridName', 'dsParams', 'selectedItems', 'ds', 'ux', 'b_7315092382398562_modalBindings', 'b_2248226175642056_columnDefaults', 'b_2248226175642056_columns'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                gridName: "contractEvents",
                dsParams: null,
                selectedItems: [],
                ds: null,
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "sm",
                },
                b_2248226175642056_columnDefaults: {
                    sortable: true,
                    filterable: true,
                    resizable: true,
                    selectable: true,
                },
                b_2248226175642056_columns: [{
                        field: "event_name",
                        type: "command",
                        name: this.$fn.pgettext("ContractEvents", "Name"),
                    },
                    {
                        field: "description",
                        name: this.$fn.pgettext("ContractEvents", "Description"),
                    },
                    {
                        field: "contract",
                        name: this.$fn.pgettext("ContractEvents", "Contract"),
                        type: "command",
                        formatter: {
                            name: "chain",
                            mode: "mapReduce",
                            formatters: [{
                                    name: "template",
                                    engine: "hb",
                                    format: "<span>\n\
  {{~#if $value }}\n\
    {{ $value.contract_number }}\n\
  {{~/if }}\n\
</span>\n\
",
                                },
                                {
                                    name: "routeLink",
                                    to: "contract",
                                    navigateOnIconClick: true,
                                    params: {
                                        id: "contract.id",
                                    },
                                },
                            ],
                        },
                    },
                    {
                        field: "timestamp",
                        name: this.$fn.pgettext("ContractEvents", "Timestamp"),
                        formatter: {
                            name: "datetime",
                        },
                    },
                    {
                        field: "identity",
                        name: this.$fn.pgettext("ContractEvents", "User"),
                        formatter: {
                            name: "user",
                        },
                    },
                ],
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.pgettext("ContractEvents|Title", "Contract Events"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_7288_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_setData_7290_getActionArgs($event) {
        return {
            path: "selectedItems",
            value: this.$refs.grid.getSelectedItems(),
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async evh_2248226175642056_selectedRowsChanged(event, scope) {
        return await this.actions.evh_2248226175642056_selectedRowsChanged.executeFromDOM(this, event, scope);
    }
    async act_2248226175642056_showModal_7292_getActionArgs($event) {
        return {
            name: "DataViewerModal",
            props: {
                content: $event.data.data.event_data,
                mode: "json",
            },
        };
    }
    async evh_2248226175642056_command_7291_getWhen($event) {
        return $event.data.column.id === 'event_name';
    }
    async act_2248226175642056_showModal_7294_getActionArgs($event) {
        return {
            name: "Job",
            props: {
                oid: $event.data.data.id,
            },
        };
    }
    async evh_2248226175642056_command_7293_getWhen($event) {
        return $event.data.column.id === 'number';
    }
    async act_2248226175642056_showModal_7296_getActionArgs($event) {
        return {
            name: "Job",
            props: {
                oid: $event.data.data.parent_id,
            },
        };
    }
    async evh_2248226175642056_command_7295_getWhen($event) {
        return $event.data.column.id === 'parent_number';
    }
    async evh_2248226175642056_command(event, scope) {
        return await this.actions.evh_2248226175642056_command.executeFromDOM(this, event, scope);
    }
    async act_6466705138206980_setData_7298_getActionArgs($event) {
        return {
            path: "dsParams.date_from",
            value: $event.data[0],
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_6466705138206980_setData_7300_getActionArgs($event) {
        return {
            path: "dsParams.date_to",
            value: $event.data[1],
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_6466705138206980_reloadSlickgrid_7302_getActionArgs($event) {
        return {
            grid: this.gridName,
        };
    }
    async evh_6466705138206980_changed(event, scope) {
        return await this.actions.evh_6466705138206980_changed.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_7288 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_7288_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_7287 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_7288,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_7287],
        });
        const act_2248226175642056_setData_7290 = new core_1.actions.SetDataAction({
            actionArgs: this.act_2248226175642056_setData_7290_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_selectedRowsChanged_7289 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_setData_7290,
            event: "selectedRowsChanged",
            displayName: "setData",
        });
        const evh_2248226175642056_selectedRowsChanged = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_selectedRowsChanged_7289],
        });
        const act_2248226175642056_showModal_7292 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2248226175642056_showModal_7292_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_command_7291 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_showModal_7292,
            event: "command",
            when: this.evh_2248226175642056_command_7291_getWhen,
            displayName: "showModal",
        });
        const act_2248226175642056_showModal_7294 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2248226175642056_showModal_7294_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_command_7293 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_showModal_7294,
            event: "command",
            when: this.evh_2248226175642056_command_7293_getWhen,
            displayName: "showModal",
        });
        const act_2248226175642056_showModal_7296 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_2248226175642056_showModal_7296_getActionArgs,
            events: [],
        });
        const evh_2248226175642056_command_7295 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_showModal_7296,
            event: "command",
            when: this.evh_2248226175642056_command_7295_getWhen,
            displayName: "showModal",
        });
        const evh_2248226175642056_command = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_command_7291, evh_2248226175642056_command_7293, evh_2248226175642056_command_7295],
        });
        const act_6466705138206980_setData_7298 = new core_1.actions.SetDataAction({
            actionArgs: this.act_6466705138206980_setData_7298_getActionArgs,
            events: [],
        });
        const evh_6466705138206980_changed_7297 = new core_1.actions.EventHandlerImpl({
            action: act_6466705138206980_setData_7298,
            event: "changed",
            displayName: "setData",
        });
        const act_6466705138206980_setData_7300 = new core_1.actions.SetDataAction({
            actionArgs: this.act_6466705138206980_setData_7300_getActionArgs,
            events: [],
        });
        const evh_6466705138206980_changed_7299 = new core_1.actions.EventHandlerImpl({
            action: act_6466705138206980_setData_7300,
            event: "changed",
            displayName: "setData",
        });
        const act_6466705138206980_reloadSlickgrid_7302 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_6466705138206980_reloadSlickgrid_7302_getActionArgs,
            events: [],
        });
        const evh_6466705138206980_changed_7301 = new core_1.actions.EventHandlerImpl({
            action: act_6466705138206980_reloadSlickgrid_7302,
            event: "changed",
            displayName: "reloadSlickgrid",
        });
        const evh_6466705138206980_changed = new core_1.actions.EventHandlerGroup({
            handlers: [evh_6466705138206980_changed_7297, evh_6466705138206980_changed_7299, evh_6466705138206980_changed_7301],
        });
        return {
            act_7315092382398562_closeModal_7288,
            evh_7315092382398562_close_7287,
            evh_7315092382398562_close,
            act_2248226175642056_setData_7290,
            evh_2248226175642056_selectedRowsChanged_7289,
            evh_2248226175642056_selectedRowsChanged,
            act_2248226175642056_showModal_7292,
            evh_2248226175642056_command_7291,
            act_2248226175642056_showModal_7294,
            evh_2248226175642056_command_7293,
            act_2248226175642056_showModal_7296,
            evh_2248226175642056_command_7295,
            evh_2248226175642056_command,
            act_6466705138206980_setData_7298,
            evh_6466705138206980_changed_7297,
            act_6466705138206980_setData_7300,
            evh_6466705138206980_changed_7299,
            act_6466705138206980_reloadSlickgrid_7302,
            evh_6466705138206980_changed_7301,
            evh_6466705138206980_changed,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], ContractEvents.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], ContractEvents.prototype, "onSize", null);
ContractEvents = __decorate([
    (0, vue_property_decorator_1.Component)()
], ContractEvents);
exports.default = ContractEvents;
vue_property_decorator_1.Vue.component("ContractEvents", ContractEvents);
